module.exports = __webpack_public_path__ + "img/image19.68bad3ce.png";